<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：商品标签列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleLabelSelect('')"
              :class="{ 'selected': productLabelManageInfo.conditions.labelCd === '' }">
              全部
            </li>
            <li v-for="(item, index) in productLabelManageInfo.labels" :key="index"
              @click="handleLabelSelect(item.labelCd)"
              :class="{ 'selected': productLabelManageInfo.conditions.labelCd === item.labelCd }">
              {{ item.labelName }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('productLabelManage.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="productLabelManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input 
                    v-model="productLabelManageInfo.conditions.prodName" 
                    :placeholder="$t('productLabelManage.inputProductName')"
                  ></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input 
                    v-model="productLabelManageInfo.conditions.productId" 
                    :placeholder="$t('productLabelManage.inputProductId')"
                  ></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryLabelMethod()">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetLabelMethod()">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 已标签商品表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('productLabelManage.labeledProducts') }}</div>
          </div>
          <div class="">
            <el-table 
              :data="productLabelManageInfo.productLabels" 
              border 
              style="width:100%"
            >
          <el-table-column 
            prop="labelName" 
            :label="$t('productLabelManage.labelName')" 
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="productId" 
            :label="$t('productLabelManage.productId')" 
            align="center"
          ></el-table-column>
          <el-table-column 
            :label="$t('productLabelManage.productImage')" 
            align="center"
          >
            <template slot-scope="scope">
              <img 
                style="width:60px;height:60px;border-radius:5px;" 
                :src="scope.row.coverPhoto"
              >
            </template>
          </el-table-column>
          <el-table-column 
            prop="categoryName" 
            :label="$t('productLabelManage.productGroup')" 
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="prodName" 
            :label="$t('productLabelManage.productName')" 
            align="center"
          ></el-table-column>
          <el-table-column 
            :label="$t('common.operation')" 
            align="center"
          >
            <template slot-scope="scope">
              <el-button 
                size="mini" 
                type="danger" 
                @click="_openDeleteLabelModel(scope.row)"
              >
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="productLabelManageInfo.conditions.page"
              :page-size="productLabelManageInfo.conditions.row"
              layout="total, prev, pager, next"
              :total="productLabelManageInfo.total"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <delete-product-label ref="deleteProductLabel"></delete-product-label>
  </div>
</template>

<script>
import { queryProductLabel, queryLabel } from '@/api/goods/productLabelApi'
import { getShopId } from '@/api/shop/shopApi'
import DeleteProductLabel from '@/components/goods/deleteProductLabel/deleteProductLabel'

export default {
  name: 'ProductLabelManage',
  components: {
    DeleteProductLabel
  },
  data() {
    return {
      productLabelManageInfo: {
        productLabels: [],
        labels: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productLabelId: '',
        conditions: {
          prodName: '',
          labelCd: '',
          productId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.productLabelManageInfo.conditions.productId = this.$route.query.productId || ''
    this.productLabelManageInfo.conditions.shopId = getShopId()
    this._listLabels()
    this._listProductLabels(1, 10)
    console.log(this.productLabelManageInfo.moreCondition)
  },
  methods: {
    handleCurrentChange(val) {
      this._listProductLabels(val, this.productLabelManageInfo.conditions.row)
    },
    async _listProductLabels(page, rows) {
      this.productLabelManageInfo.conditions.page = page
      this.productLabelManageInfo.conditions.row = rows
      try {
        const res = await queryProductLabel(this.productLabelManageInfo.conditions)
        this.productLabelManageInfo.total = res.total
        this.productLabelManageInfo.records = res.records
        this.productLabelManageInfo.productLabels = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listLabels() {
      try {
        const res = await queryLabel({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.productLabelManageInfo.labels = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openDeleteLabelModel(product) {
      this.$refs.deleteProductLabel.open(product)
    },
    _queryLabelMethod() {
      this._listProductLabels(1, this.productLabelManageInfo.conditions.row)
    },
    _resetLabelMethod() {
      this.productLabelManageInfo.conditions = {
        prodName: '',
        labelCd: '',
        productId: '',
        shopId: getShopId(),
        page: 1,
        row: 10
      }
      this._listProductLabels(1, 10)
    },
    handleLabelSelect(labelCd) {
      this.productLabelManageInfo.conditions.labelCd = labelCd
      this.productLabelManageInfo.conditions.page = 1
      this._listProductLabels(1, this.productLabelManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0,0,0,.1);
}
.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  clear: both;
  padding: 15px 20px 20px;
}

/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>